import styled from 'styled-components';
import { StyledFieldInput } from '../FieldInput/styled';
import Icon from '../../../components/Icon';

export const StyledFieldSelect = styled(StyledFieldInput).attrs({
  as: 'select',
})`
  height: unset;
  line-height: ${(p) => p.theme.space[7]};
  padding-top: ${(p) => p.theme.space[0]};
  padding-bottom: ${(p) => p.theme.space[0]};
`;

export const StyledFieldSelectIcon = styled(Icon).attrs({
  name: 'arrow-down',
})`
  position: absolute;
  top: ${(p) => p.theme.space[2]};
  right: ${(p) => p.theme.space[5]};
`;

export const StyledFieldSelectWrapper = styled.div`
  position: relative;
`;
